import React, { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18NProvider, LocaleProvider } from 'client/i18n/context';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';
import { ExperimentationProvider } from './Experimentation';
import { ReactQueryProvider } from './ReactQuery';
import { QuickUploadFileProvider } from './QuickUploadFile';

export function AppProviders({
  locale = 'en',
  children,
}: {
  locale?: string;
  children: ReactNode;
}) {
  return (
    <HelmetProvider>
      <LocaleProvider locale={locale}>
        <I18NProvider>
          <ReactQueryProvider>
            <CurrentUserProvider>
              <ExperimentationProvider>
                <FeatureFlagsProvider>
                  <UnsavedChangesWarningProvider>
                    <NetworkRoleProvider>
                      <BrowserSizeProvider>
                        <QuickUploadFileProvider>
                          {children}
                        </QuickUploadFileProvider>
                      </BrowserSizeProvider>
                    </NetworkRoleProvider>
                  </UnsavedChangesWarningProvider>
                </FeatureFlagsProvider>
              </ExperimentationProvider>
            </CurrentUserProvider>
          </ReactQueryProvider>
        </I18NProvider>
      </LocaleProvider>
    </HelmetProvider>
  );
}
